// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"az_a2b"};